import { Group, Text, Code, Paper, SegmentedControl } from "@mantine/core";
import { useState } from "react";
import Markdown from "../_Common/Markdown";
import CopyTextActionIcon from "./CopyTextActionIcon";

export default function PromptText({ text, defaultDisplayMode = "markdown" }) {
  const [displayMode, setDisplayMode] = useState(defaultDisplayMode);

  if (!text)
    return (
      <Paper radius="lg" mb="md" p="md" withBorder>
        <Text>No response present / an error occurred</Text>
      </Paper>
    );
  return (
    <Paper radius="lg" mb="md" p="md" withBorder>
      <Group mb="xs" justify="space-between">
        <SegmentedControl
          value={displayMode}
          onChange={setDisplayMode}
          data={[
            { label: "Markdown", value: "markdown" },
            { label: "Raw", value: "raw" },
            { label: "Monospace", value: "mono" },
          ]}
        />

        <CopyTextActionIcon text={text} />
      </Group>
      <div style={{ position: "relative" }}>
        {displayMode == "markdown" && (
          <Markdown>{text}</Markdown>
        )}
        {displayMode == "mono" && (
          <Code style={{ whiteSpace: "pre-wrap" }} block>
            {text}
          </Code>
        )}
        {displayMode == "raw" && (
          <Text style={{ whiteSpace: "pre-wrap" }}>{text}</Text>
        )}
      </div>
    </Paper>
  );
}
